import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from "@angular/core";
import { S25Icons } from "./s25.icon.const";
import { TypeManagerDecorator } from "../../main/type.map.service";

@TypeManagerDecorator("s25-ng-icon")
@Component({
    selector: "s25-ng-icon",
    template: `
        @if (Icons[type] && !Icons[type].dataImage) {
            <svg
                class="icon {{ svgClass }}"
                role="img"
                [style.width]="size"
                [style.height]="size"
                [attr.autoDarkMode]="autoDarkMode && Icons[type].hasDarkMode ? 'on' : 'off'"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>{{ label || Icons[type].title }}</title>
                <use
                    class="noPointerEvents light"
                    attr.href="./resources/typescript/assets/css-compiled/images/sprite.svg#{{ Icons[type].name }}"
                ></use>
                @if (Icons[type].hasDarkMode) {
                    <use
                        class="noPointerEvents dark"
                        attr.href="./resources/typescript/assets/css-compiled/images/sprite.svg#{{
                            Icons[type].name
                        }}--dark"
                    ></use>
                }
            </svg>
        }
        @if (Icons[type]?.dataImage) {
            <div
                [style.background-image]="'url(' + Icons[type].dataImage + ')'"
                [style.height]="Icons[type].size.height"
                [style.width]="Icons[type].size.width"
                class="dataImage"
            ></div>
        }
    `,
    styles: `
        :host {
            display: inline-block;
        }

        .icon {
            display: inline-block;
            vertical-align: middle;
            height: var(--icon-size, 1.5em);
            width: var(--icon-size, 1.5em);
        }

        .noPointerEvents {
            pointer-events: none;
        }

        .dark {
            display: none;
        }

        ::ng-deep .nm-party--on s25-ng-icon [autoDarkMode="on"] .light {
            display: none;
        }

        ::ng-deep .nm-party--on s25-ng-icon [autoDarkMode="on"] .dark {
            display: initial;
        }

        .dataImage {
            background-repeat: no-repeat;
            background-position: center;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    standalone: true,
})
export class S25IconComponent {
    @Input({ required: true }) type: S25Icons.Name;
    @Input() label: string;
    @Input() size: number | string;
    @Input() autoDarkMode = false;
    @Input() svgClass: string = "";

    public Icons = S25Icons.untyped;
}
